import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import ContributionRecording from './pages/contribution-recording';
import GroupManagement from './pages/group-management';
import Login from './pages/login';
import MemberProfile from './pages/member-profile';
import Reports from './pages/reports';
import Register from './pages/register';
import MemberDashboard from './pages/member-dashboard';
import SubscriptionPlans from './pages/subscription-plans';
import PaymentProcessing from './pages/payment-processing';
import AccessControlDashboard from './pages/access-control-dashboard';
import SuperAdminDashboard from './pages/super-admin-dashboard';
import SubscriptionPlanManagement from './pages/subscription-plan-management';
import SubscriptionManagement from './pages/subscription-management';
import PlatformAnalytics from './pages/platform-analytics';
import LoanRequest from './pages/loan-request';
import PaymentInstructions from './pages/payment-instructions';
import PaymentStatus from './pages/payment-status';
import NotificationsPage from './pages/notifications';
import AccountSettings from './pages/account-settings';
import AdvancedAnalytics from './pages/advanced-analytics';
import GroupAdminMembers from './pages/group-admin-members';
import InvoicesPage from './pages/invoices';
import DataBackup from './pages/data-backup';
import LoanManagement from './pages/loan-management';
import ForgotPassword from './pages/forgot-password';
import ActivityPage from './pages/activity';

function AppRoutes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<ProtectedRoute access="public"><Login /></ProtectedRoute>} />
          <Route path="/login" element={<ProtectedRoute access="public"><Login /></ProtectedRoute>} />
          <Route path="/register" element={<ProtectedRoute access="public"><Register /></ProtectedRoute>} />
          <Route path="/forgot-password" element={<ProtectedRoute access="public"><ForgotPassword /></ProtectedRoute>} />
          <Route path="/subscription-plans" element={<ProtectedRoute access="public"><SubscriptionPlans /></ProtectedRoute>} />

          <Route path="/member-dashboard" element={<ProtectedRoute access="authenticated"><MemberDashboard /></ProtectedRoute>} />
          <Route path="/loan-request" element={<ProtectedRoute access="authenticated"><LoanRequest /></ProtectedRoute>} />
          <Route path="/loan-management" element={<ProtectedRoute access="authenticated"><LoanManagement /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute access="authenticated"><Reports /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute access="authenticated"><NotificationsPage /></ProtectedRoute>} />
          <Route path="/payment-status" element={<ProtectedRoute access="authenticated"><PaymentStatus /></ProtectedRoute>} />
          <Route path="/payment-instructions" element={<ProtectedRoute access="authenticated"><PaymentInstructions /></ProtectedRoute>} />
          <Route path="/activity" element={<ProtectedRoute access="authenticated"><ActivityPage /></ProtectedRoute>} />
          <Route path="/member-profile" element={<ProtectedRoute access="authenticated"><MemberProfile /></ProtectedRoute>} />

          <Route path="/admin-dashboard" element={<ProtectedRoute access="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/advanced-analytics" element={<ProtectedRoute access="admin"><AdvancedAnalytics /></ProtectedRoute>} />

          <Route path="/subscription-management" element={<ProtectedRoute access="billing"><SubscriptionManagement /></ProtectedRoute>} />
          <Route path="/invoices" element={<ProtectedRoute access="billing"><InvoicesPage /></ProtectedRoute>} />

          <Route path="/contribution-recording" element={<ProtectedRoute access="canRecord"><ContributionRecording /></ProtectedRoute>} />
          <Route path="/group-management" element={<ProtectedRoute access="canManageGroups"><GroupManagement /></ProtectedRoute>} />
          <Route path="/group-admin/members" element={<ProtectedRoute access="canManageGroups"><GroupAdminMembers /></ProtectedRoute>} />

          <Route path="/super-admin-dashboard" element={<ProtectedRoute access="superAdmin"><SuperAdminDashboard /></ProtectedRoute>} />
          <Route path="/payment-processing" element={<ProtectedRoute access="superAdmin"><PaymentProcessing /></ProtectedRoute>} />
          <Route path="/subscription-plan-management" element={<ProtectedRoute access="superAdmin"><SubscriptionPlanManagement /></ProtectedRoute>} />
          <Route path="/platform-analytics" element={<ProtectedRoute access="superAdmin"><PlatformAnalytics /></ProtectedRoute>} />
          <Route path="/access-control-dashboard" element={<ProtectedRoute access="superAdmin"><AccessControlDashboard /></ProtectedRoute>} />
          <Route path="/data-backup" element={<ProtectedRoute access="superAdmin"><DataBackup /></ProtectedRoute>} />
          <Route path="/account-settings" element={<ProtectedRoute access="superAdmin"><AccountSettings /></ProtectedRoute>} />

          <Route path="/financial-literacy" element={<Navigate to="/member-dashboard" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default AppRoutes;
